import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { fn_init_info } from "../../function/FnBodyInit";
import MainTopContainer from "./top/MainTopContainer";
import OrderDetail from "../../pages/layers/orderDetail/OrderDetail";
import ShopMemoView from "../../views/main/body/List/detail/ShopMemoView";
import OrderCancelView from "../../views/main/body/layer/OrderCancelView";
import OrderRejectView from "../../views/main/body/layer/OrderRejectView";
import SoldOutView from "../../views/main/body/layer/SoldOutView";
import RePrintView from "../../views/main/body/layer/RePrintView";
import VoCsView from "../../views/main/body/layer/VoCsView";
import DlvConnectView from "../../views/main/body/layer/DlvConnectView";
import DlvConnectAdd from "../../views/main/body/layer/DlvConnectAdd";
import DlvConnectResult from "../../views/main/body/layer/DlvConnectResult";
import VoCsAgreeView from "../../views/main/body/layer/VoCsAgreeView";
import ManagerAuthView from "../../views/main/body/layer/ManagerAuthView";
import OriginAddView from "../../views/main/body/layer/OriginAddView";
import OnboardingView from "../../views/main/body/layer/OnboardingView";
import OnboardingView_01 from "../../views/main/body/layer/OnboardingStep_01";
import OnboardingView_02 from "../../views/main/body/layer/OnboardingStep_02";
import OnboardingView_03 from "../../views/main/body/layer/OnboardingStep_03";
import OnboardingView_04 from "../../views/main/body/layer/OnboardingStep_04";
import PartialCancelView from "../../views/main/body/layer/PartialCancelView";
import CustomerExpectTimeView from "../../views/main/body/layer/CustomerExpectTimeView";
import CustomerExpectTimeYgyView from "../../views/main/body/layer/CustomerExpectTimeYgyView";
import AddressSearchView from "../../views/main/body/layer/AddressSearchView";
import DeliveryCallView from "../../views/main/body/layer/DeliveryCallView";
import CheckDepositView from "../../views/main/body/layer/CheckDepositView";
import WoodilveryChangeView from "../../views/main/body/layer/WoodilveryChangeView";
import ReturnList from "../../views/main/body/layer/ReturnList";
import IncompleteMenu from "../../views/main/body/layer/IncompleteMenu";
import AlertView from "../../views/main/body/layer/AlertView";
import MainOrderListContainer from "./MainOrderListContainer";
import SettingEndOrderView from "../../views/setting/SettingEndOrderView";
import SettingDefaultDeliveryView from "../../views/setting/SettingDefaultDeliveryView";
import SettingDefaultAddressView from "../../views/setting/pages/address/SettingDefaultAddressView";
import SettingDefaultUseView from "../../views/setting/pages/status/SettingDefaultUseView";
import SettingDefaultReceiptView from "../../views/setting/pages/receipt/SettingDefaultReceiptView";
import SettingDefaultPrinterView from "../../views/setting/pages/printer/SettingDefaultPrinterView";
import SettingProdSoldoutView from "../../views/setting/SettingProdSoldoutView";
import SettingNoticeView from "../../views/setting/SettingNoticeView";
import SettingDefaultSelfDeliveryView from "../../views/setting/SettingDefaultSelfDeliveryView";
import {
  fn_pos_accept_order_push,
  fn_pos_order_init_list_page,
  fn_pos_reject_order_push,
  fn_search_orderDetail,
  fn_pos_user_info_push,
  fn_baemin_service_statue,
} from "../../function/FnPosPush";
import { fn_posOrderLayer, fn_closeDetailView } from "../../function/FnBodyDetail";
import {
  fn_bridge_order_state,
  posBridge,
  fn_notify_close,
  fn_bridge_pos_order_list,
  fn_bridge_state_notify,
  fn_bridge_pos_order_reload,
  fn_bridge_text_notify,
} from "function/FnPosBridge";
import { fn_pos_order_notify_setting } from "function/FnBodyStep";
import OrderEndDetail from "../../pages/layers/orderDetail/OrderEndDetail";
import OrderCompleteView from "../../views/main/body/layer/OrderCompleteView";
import SettingDefaultRequestMemoView from "../../views/setting/SettingDefaultRequestMemoView";
import SettingDefaultManagerSetView from "../../views/setting/SettingDefaultManagerSetView";
import OrderPaymentAlertView from "../../views/main/body/layer/OrderPaymentAlertView";
import SalesProduct from "views/main/body/Sales/SalesProduct";
import SalesTime from "views/main/body/Sales/SalesTime";
import SalesProductDetail from "views/main/body/Sales/SalesProductDetail";
import SalesProductEtc from "views/main/body/Sales/SalesProductEtc";
import SalesCalendar from "views/main/body/Sales/SalesCalendar";
import { fn_setting_config } from "http/SettingConn";
import { reload_order_list_all, api_order_type, api_order_list } from "http/OrderConn";
import { baerminUseYn, baeminUsePosNo, posOrderTab, posOrdermMbileOrderFg } from "utils/Utils";
import DeliveryConnectView from "views/main/body/layer/DeliveryConnectView";
import DeliveryConnectComplete from "views/main/body/layer/DeliveryConnectComplete";
import DeliveryConnectConfirm from "views/main/body/layer/DeliveryConnectConfirm";
import DlvConnectShopResult from "views/main/body/layer/DlvConnectShopResult";
import LeftSidebar from "components/layouts/LeftSidebar";
import GlobalModalManager from "components/modal";
import NaverConnectedView from "../../views/naver/views/connected/NaverConnectedView";
import NaverDisconnectedView from "../../views/naver/views/disconnected/NaverDisconnectedView";
import NaverBizitemView from "../../views/naver/views/bizitem/NaverBizitemView";
import NaverCallback from "../../views/naver/views/callback/NaverCallback";
import { NaverLogout } from "views/naver/views/callback/NaverLogout";

@inject("rootStore")
@inject("component")
@observer
class MainContainer extends Component {
  componentDidMount() {
    const { rootStore, targetComponent, component } = this.props;
    fn_init_info(rootStore);
    if (component[targetComponent] != undefined && targetComponent != "Main") {
      if (component[targetComponent].prototype?.hasOwnProperty("fnReload")) {
        component[targetComponent].prototype.fnReload(rootStore, targetComponent);
      }
    }
  }

  render() {
    const { rootStore, targetComponent } = this.props;
    let topText;
    switch (window.location.pathname) {
      case "/":
      case "/order_list":
        {
          (rootStore.settingStore.getManagerSetting?.orderEnd
            ? rootStore.settingStore.getManagerSetting?.orderEnd
            : "N") == "Y"
            ? (topText = "완료된 주문")
            : (topText = "주문현황");
        }
        break;
      case "/setting/end_order":
        topText = "지난 주문내역";
        break;
      case "/setting/prod_soldout":
        topText = "상품 품절 관리";
        break;
      case "/setting/notice":
        topText = "공지사항";
        break;
      case "/setting/sales/product":
        topText = "배달앱 매출 분석";
        break;
      case "/setting/sales/time":
        topText = "배달앱 매출 분석";
        break;
      case "/setting/sales/calendar":
        topText = "일자별 매출";
        break;
      case "/setting/default/use":
      case "/setting/default/order":
      case "/setting/default/address":
      case "/setting/default/delivery":
      case "/setting/default/self_delivery":
      case "/setting/default/printer_setting":
      case "/setting/default/manager_setting":
      case "/setting/default/request_memo":
      case "/setting/default/receipt":
        topText = "설정";
        break;
      case "/naver/connected":
      case "/naver/disconnected":
      case "/naver/bizitem":
      case "/okgo/naver/callback":
        topText = "네이버 주문 연동";
        break;
      default:
        topText = "주문현황";
        break;
    }

    global.fn_web_view_check = function (data) {
      let ret = posBridge(
        rootStore,
        '{"command" : "WEB_VIEW_CHECK", "timestamp" : "' +
          data +
          '", "status" : "' +
          rootStore.rabbitMqStore.getRmqCheck +
          '"}',
        ""
      );
      return;
    };

    global.fn_pos_reject_order = function (mobileOrderNo) {
      fn_pos_reject_order_push(rootStore, mobileOrderNo);
      return;
    };

    global.fn_pos_accept_order = function (mobileOrderNo, min) {
      fn_pos_accept_order_push(rootStore, mobileOrderNo, min);
      return;
    };

    global.fn_pos_order_detail = function (mobileOrderNo) {
      fn_search_orderDetail(rootStore, mobileOrderNo, "order");
      return;
    };

    global.fn_pos_user_info = function (userId, userNm, auth) {
      localStorage.setItem("userId", userId);
      localStorage.setItem("userNm", userNm);
      localStorage.setItem("auth", auth);
      fn_pos_user_info_push(rootStore, userId, userNm, auth);
      return;
    };

    global.fn_config_change_signal = function () {
      fn_setting_config(rootStore, "pos");
      return;
    };

    global.fn_pos_order_init_list = function () {
      fn_pos_order_init_list_page();
      return;
    };

    //배달 상태값 업데이트 받을때
    global.fn_pos_delivery_status = function (data) {
      let jsonData = JSON.parse(data);

      if (jsonData.deliveryStatus == "COOK_COMPLETED") {
        rootStore.viewStore.setDetailBaeminView(false);
      } else if (jsonData.deliveryStatus == "START_TO_PICKUP_LOCATION") {
        rootStore.settingStore.setPosNotifySound("startToPickupLocationAlarm");
        fn_bridge_text_notify(rootStore, "라이더가 곧 가게에 도착합니다", jsonData.orderNo.slice(-4), "배달");
      } else if (jsonData.deliveryStatus == "SHORT_TERM_UNALLOCATED") {
        rootStore.settingStore.setPosNotifySound("unallocatedAlarm");
        fn_bridge_text_notify(rootStore, "라이더 배정이 지연되고 있습니다", jsonData.orderNo.slice(-4), "배달");
      } else if (jsonData.deliveryStatus == "LONG_TERM_UNALLOCATED") {
        rootStore.settingStore.setPosNotifySound("unallocatedAlarm");
        fn_bridge_text_notify(rootStore, "라이더 배정이 지연되고 있습니다", jsonData.orderNo.slice(-4), "배달");
      } else if (jsonData.deliveryStatus == "DDANGBAEDAL_COOK") {
        rootStore.settingStore.setPosNotifySound("DDANGBAEDALCOOK");
        fn_bridge_text_notify(rootStore, "땡배달 조리시작", jsonData.orderNo.slice(-5), "배달");
      } else if (jsonData.deliveryStatus == "DDANGBAEDAL_RIDER") {
        rootStore.settingStore.setPosNotifySound("DDANGBAEDALRIDER");
        fn_bridge_text_notify(rootStore, "땡배달 라이더 곧 도착", jsonData.orderNo.slice(-5), "배달");
      } 

      return;
    };

    //배민 연결상태 값
    global.fn_pos_service_status = function (data) {
      let jsonData = JSON.parse(data);
      fn_baemin_service_statue(rootStore, jsonData);
      return;
    };

    //상세보기
    global.fn_pos_show_order_view = function (data) {
      let jsonData = JSON.parse(data);
      fn_posOrderLayer(rootStore, jsonData.orderNo);
      return;
    };

    //배민 주문 상태값 받을때
    global.fn_pos_order_status = function (data) {
      let jsonData = JSON.parse(data);

      if (jsonData.orderStatus == "RECEIPT") {
        fn_bridge_order_state(rootStore, jsonData.orderNo, "", jsonData.orderNo, true);
        fn_notify_close(rootStore);
      } else if (jsonData.orderStatus == "CANCEL") {
        fn_notify_close(rootStore);
      }

      reload_order_list_all(rootStore);
      fn_closeDetailView(rootStore);
      rootStore.viewStore.setDetailBaeminView(false);
      return;
    };

    global.fn_pos_close_order_view = function (data) {
      rootStore.viewStore.setDetailBaeminView(false);
      return;
    };

    //배민 연결상태 값 추가된거
    global.fn_pos_response = function (data) {
      if (baerminUseYn(rootStore) && baeminUsePosNo(rootStore)) {
        let jsonData = JSON.parse(data);
        if (jsonData.procName != "UpdateDeliveryStatus") {
          if (400 < jsonData.code && jsonData.code < 500) {
            rootStore.viewStore.setDetailBaeminView(false);
            rootStore.layerStore.setLayerAlertType("baemin_status_off");
            rootStore.layerStore.setLayerAlertView(true);
          } else {
            rootStore.settingStore.setBaeminUseStatus("baeminStatus", "E");
          }
          return;
        }
      }
    };

    //현장주문만 보기(pos/kiosk)
    global.fn_pos_order_create = function (jsonData) {
      let obj = JSON.parse(jsonData);
      const order = obj.data.list[0];
      rootStore.rabbitMqStore.addRabbitReadyNew(order.mobileOrderNo);
      if (posOrderTab(rootStore)) {
        fn_bridge_pos_order_list(rootStore);
      } else {
        api_order_list(rootStore);
        fn_closeDetailView(rootStore);
      }
      api_order_type(rootStore);
      order.type = "CID_ORDER_NEW";
      const notifyText = order?.maxOidSeqNo > 1 ? "주문이 수정되었습니다." : "접수 처리되었습니다.";
      fn_bridge_state_notify(rootStore, order, notifyText);
    };

    //현장주문만 보기(pos/kiosk) 상태변경
    global.fn_pos_order_changestep = function (jsonData) {
      let data = JSON.parse(jsonData);
      if (posOrdermMbileOrderFg(data.mobileOrderFg)) {
        fn_pos_order_notify_setting(rootStore, data);
      } else {
        fn_pos_accept_order_push(rootStore, data.mobileOrderNo, data.min);
      }
    };

    //현장주문만 보기(pos/kiosk) 전체완료 상태변경
    global.fn_pos_order_allcomplete = function () {
      if (posOrderTab(rootStore)) fn_bridge_pos_order_reload(rootStore);
    };

    let viewCompoent;
    switch (targetComponent) {
      case "Main":
      case "MainOrderListContainer":
        viewCompoent = <MainOrderListContainer rootStore={rootStore} />;
        break;
      case "SettingEndOrderView":
        viewCompoent = <SettingEndOrderView rootStore={rootStore} />;
        break;
      case "SettingProdSoldoutView":
        viewCompoent = <SettingProdSoldoutView rootStore={rootStore} />;
        break;
      case "SettingDefaultUseView":
        viewCompoent = <SettingDefaultUseView rootStore={rootStore} />;
        break;
      case "SettingDefaultReceiptView":
        viewCompoent = <SettingDefaultReceiptView rootStore={rootStore} />;
        break;
      case "SettingDefaultAddressView":
        viewCompoent = <SettingDefaultAddressView rootStore={rootStore} />;
        break;
      case "SettingDefaultDeliveryView":
        viewCompoent = <SettingDefaultDeliveryView rootStore={rootStore} />;
        break;
      case "SettingDefaultSelfDeliveryView":
        viewCompoent = <SettingDefaultSelfDeliveryView rootStore={rootStore} />;
        break;
      case "SettingDefaultRequestMemoView":
        viewCompoent = <SettingDefaultRequestMemoView rootStore={rootStore} />;
        break;
      case "SettingDefaultPrinterView":
        viewCompoent = <SettingDefaultPrinterView rootStore={rootStore} />;
        break;
      case "SettingDefaultManagerSetView":
        viewCompoent = <SettingDefaultManagerSetView rootStore={rootStore} />;
        break;
      case "SettingNoticeView":
        viewCompoent = <SettingNoticeView rootStore={rootStore} />;
        break;
      case "SalesProduct":
        viewCompoent = <SalesProduct rootStore={rootStore} />;
        break;
      case "SalesTime":
        viewCompoent = <SalesTime rootStore={rootStore} />;
        break;
      case "SalesCalendar":
        viewCompoent = <SalesCalendar rootStore={rootStore} />;
        break;
      case "NaverConnectedView":
        viewCompoent = <NaverConnectedView rootStore={rootStore} />;
        break;
      case "NaverDisconnectedView":
        viewCompoent = <NaverDisconnectedView rootStore={rootStore} />;
        break;
      case "NaverBizitemView":
        viewCompoent = <NaverBizitemView rootStore={rootStore} />;
        break;
      case "NaverCallback":
        viewCompoent = <NaverCallback rootStore={rootStore} />;
        break;
      case "NaverLogout":
        viewCompoent = <NaverLogout rootStore={rootStore} />;
        break;

      default:
        viewCompoent = <MainOrderListContainer rootStore={rootStore} />;
        break;
    }

    return (
      <div id="dummerWrap">
        {!targetComponent.startsWith("Naver") && <MainTopContainer topText={topText} />}
        {viewCompoent}
        <LeftSidebar rootStore={rootStore} />
        <OrderDetail rootStore={rootStore} /> {/*주문상세*/}
        <OrderEndDetail rootStore={rootStore} /> {/*지난주문상세*/}
        <ShopMemoView rootStore={rootStore} /> {/*매장메모입력*/}
        <OrderCancelView rootStore={rootStore} /> {/*주문취소사유*/}
        <OrderRejectView rootStore={rootStore} /> {/*주문거절사유*/}
        <OrderCompleteView rootStore={rootStore} /> {/*주문완료 확인창*/}
        <SoldOutView rootStore={rootStore} /> {/*거절품절*/}
        <RePrintView rootStore={rootStore} /> {/*재출력*/}
        <CustomerExpectTimeView rootStore={rootStore} /> {/*고객예상수령시간*/}
        <CustomerExpectTimeYgyView rootStore={rootStore} /> {/*요기요고객예상수령시간*/}
        <AddressSearchView rootStore={rootStore} /> {/*주소검색*/}
        <DeliveryCallView rootStore={rootStore} /> {/*배달요청*/}
        <CheckDepositView rootStore={rootStore} /> {/*수금확인*/}
        <WoodilveryChangeView rootStore={rootStore} /> {/*우리동네딜리버리 자동변경*/}
        <AlertView rootStore={rootStore} /> {/*공통 확인창 뷰*/}
        <OrderPaymentAlertView rootStore={rootStore} /> {/*포장 후불결제 알람*/}
        <VoCsView rootStore={rootStore} /> {/*문의접수*/}
        <DlvConnectView rootStore={rootStore} /> {/*연동가능 배달대행사 목록*/}
        <DlvConnectShopResult rootStore={rootStore} /> {/*연동가능 배달대행사 상점 목록 */}
        <DlvConnectAdd rootStore={rootStore} /> {/*연동가능 배달대행사 추가*/}
        <DlvConnectResult rootStore={rootStore} /> {/*연동가능 배달대행사 추가 결과*/}
        <GlobalModalManager rootStore={rootStore} />
        <VoCsAgreeView rootStore={rootStore} /> {/*개인정보처리방침*/}
        <ManagerAuthView rootStore={rootStore} /> {/*관리자인증*/}
        <OriginAddView rootStore={rootStore} /> {/*원산지입력*/}
        <OnboardingView rootStore={rootStore} /> {/*온보딩*/}
        <OnboardingView_01 rootStore={rootStore} /> {/*온보딩Step01*/}
        <OnboardingView_02 rootStore={rootStore} /> {/*온보딩Step02*/}
        <OnboardingView_03 rootStore={rootStore} /> {/*온보딩Step03*/}
        <OnboardingView_04 rootStore={rootStore} /> {/*온보딩Step04*/}
        <PartialCancelView rootStore={rootStore} /> {/*부분취소안내*/}
        <SalesProductDetail rootStore={rootStore} /> {/*상품별매출조회상세*/}
        <SalesProductEtc rootStore={rootStore} /> {/*상품매출누락조회*/}
        <ReturnList rootStore={rootStore} /> {/*반품 매출 미처리 목록*/}
        <IncompleteMenu rootStore={rootStore} /> {/*미완료 메뉴별 수량*/}
        <DeliveryConnectView rootStore={rootStore} />
        {/* 배달앱 연동 설정 연동 */}
        <DeliveryConnectComplete rootStore={rootStore} />
        {/* 배달연동 완료 */}
        <DeliveryConnectConfirm rootStore={rootStore} />
        {/* 연동매장확인 */}
      </div>
    );
  }
}

export default MainContainer;
